var map = {
	"./PlayAlongNow-Logo_Invert.svg": "./src/assets/images/PlayAlongNow-Logo_Invert.svg",
	"./PlayPause/arrow-lite.png": "./src/assets/images/PlayPause/arrow-lite.png",
	"./PlayPause/hc-pause.png": "./src/assets/images/PlayPause/hc-pause.png",
	"./PlayPause/hc-play.png": "./src/assets/images/PlayPause/hc-play.png",
	"./PlayPause/infinity.png": "./src/assets/images/PlayPause/infinity.png",
	"./PlayPause/timer.png": "./src/assets/images/PlayPause/timer.png",
	"./automation-controller-icon.svg": "./src/assets/images/automation-controller-icon.svg",
	"./automation-initplay-icon.svg": "./src/assets/images/automation-initplay-icon.svg",
	"./automation-pause-icon.svg": "./src/assets/images/automation-pause-icon.svg",
	"./automation-play-icon.svg": "./src/assets/images/automation-play-icon.svg",
	"./automation-rewind-icon.svg": "./src/assets/images/automation-rewind-icon.svg",
	"./check-icon.svg": "./src/assets/images/check-icon.svg",
	"./dragndrop-dots.png": "./src/assets/images/dragndrop-dots.png",
	"./horizontal-line.svg": "./src/assets/images/horizontal-line.svg",
	"./host-command-arrow-down.svg": "./src/assets/images/host-command-arrow-down.svg",
	"./host-command-icon-arrow-push.svg": "./src/assets/images/host-command-icon-arrow-push.svg",
	"./host-command-icon-arrow-start-kill.svg": "./src/assets/images/host-command-icon-arrow-start-kill.svg",
	"./host_command-addstar.svg": "./src/assets/images/host_command-addstar.svg",
	"./icon-arrow-down.svg": "./src/assets/images/icon-arrow-down.svg",
	"./icon-arrow.svg": "./src/assets/images/icon-arrow.svg",
	"./icon-football.svg": "./src/assets/images/icon-football.svg",
	"./icon-globe.svg": "./src/assets/images/icon-globe.svg",
	"./icon-live.svg": "./src/assets/images/icon-live.svg",
	"./icon-lock-black.svg": "./src/assets/images/icon-lock-black.svg",
	"./icon-lock-gray.svg": "./src/assets/images/icon-lock-gray.svg",
	"./icon-lock-white.svg": "./src/assets/images/icon-lock-white.svg",
	"./icon-lock.svg": "./src/assets/images/icon-lock.svg",
	"./icon-pen.svg": "./src/assets/images/icon-pen.svg",
	"./icon-start-date.svg": "./src/assets/images/icon-start-date.svg",
	"./icon-start-schedule.svg": "./src/assets/images/icon-start-schedule.svg",
	"./icon-start-time.svg": "./src/assets/images/icon-start-time.svg",
	"./icon-volume_off.svg": "./src/assets/images/icon-volume_off.svg",
	"./icon-volume_on.svg": "./src/assets/images/icon-volume_on.svg",
	"./icon-x.svg": "./src/assets/images/icon-x.svg",
	"./import-export-arrows.svg": "./src/assets/images/import-export-arrows.svg",
	"./menu-prize_chest-icon.svg": "./src/assets/images/menu-prize_chest-icon.svg",
	"./pa-icon-white.svg": "./src/assets/images/pa-icon-white.svg",
	"./pending-indicator-black.svg": "./src/assets/images/pending-indicator-black.svg",
	"./pending-indicator.svg": "./src/assets/images/pending-indicator.svg",
	"./pending-inner.svg": "./src/assets/images/pending-inner.svg",
	"./pending-outer.svg": "./src/assets/images/pending-outer.svg",
	"./play-next.svg": "./src/assets/images/play-next.svg",
	"./play-resolved.svg": "./src/assets/images/play-resolved.svg",
	"./playalong-bg-demo_start.jpg": "./src/assets/images/playalong-bg-demo_start.jpg",
	"./playalong-default.jpg": "./src/assets/images/playalong-default.jpg",
	"./playalong-token.svg": "./src/assets/images/playalong-token.svg",
	"./preplay-interruption-icon.svg": "./src/assets/images/preplay-interruption-icon.svg",
	"./preplay-plus-blue.svg": "./src/assets/images/preplay-plus-blue.svg",
	"./preplay-session-icon.svg": "./src/assets/images/preplay-session-icon.svg",
	"./preplay-sponsor-star6.svg": "./src/assets/images/preplay-sponsor-star6.svg",
	"./preplay-type.png": "./src/assets/images/preplay-type.png",
	"./preplay-unresolved.svg": "./src/assets/images/preplay-unresolved.svg",
	"./preplay-up-arrow-black.webp": "./src/assets/images/preplay-up-arrow-black.webp",
	"./preplay-up-arrow-white.svg": "./src/assets/images/preplay-up-arrow-white.svg",
	"./preplay-up-arrow-white.webp": "./src/assets/images/preplay-up-arrow-white.webp",
	"./preview-icon.svg": "./src/assets/images/preview-icon.svg",
	"./preview/PlayAlongNow-Logo_Invert.svg": "./src/assets/images/preview/PlayAlongNow-Logo_Invert.svg",
	"./preview/icon-football-black.svg": "./src/assets/images/preview/icon-football-black.svg",
	"./preview/icon-football.svg": "./src/assets/images/preview/icon-football.svg",
	"./preview/icon-lock.svg": "./src/assets/images/preview/icon-lock.svg",
	"./preview/icon-menu.svg": "./src/assets/images/preview/icon-menu.svg",
	"./preview/playalong-kickoff.jpg": "./src/assets/images/preview/playalong-kickoff.jpg",
	"./preview/star-icon-gold.svg": "./src/assets/images/preview/star-icon-gold.svg",
	"./preview/symbol-prepick.svg": "./src/assets/images/preview/symbol-prepick.svg",
	"./profile-image.jpg": "./src/assets/images/profile-image.jpg",
	"./record-reset-icon.svg": "./src/assets/images/record-reset-icon.svg",
	"./reuse.svg": "./src/assets/images/reuse.svg",
	"./sportoco-logo.svg": "./src/assets/images/sportoco-logo.svg",
	"./star-icon-dark-excl.svg": "./src/assets/images/star-icon-dark-excl.svg",
	"./star-icon-dark-q.svg": "./src/assets/images/star-icon-dark-q.svg",
	"./star-icon-dark.svg": "./src/assets/images/star-icon-dark.svg",
	"./star-icon-gold.svg": "./src/assets/images/star-icon-gold.svg",
	"./symbol-gm.svg": "./src/assets/images/symbol-gm.svg",
	"./symbol-gm_white.svg": "./src/assets/images/symbol-gm_white.svg",
	"./symbol-liveplay.svg": "./src/assets/images/symbol-liveplay.svg",
	"./symbol-liveplay_white.svg": "./src/assets/images/symbol-liveplay_white.svg",
	"./symbol-prepick.svg": "./src/assets/images/symbol-prepick.svg",
	"./symbol-prepick_white.svg": "./src/assets/images/symbol-prepick_white.svg",
	"./symbol-prize.svg": "./src/assets/images/symbol-prize.svg",
	"./symbol-prize_white.svg": "./src/assets/images/symbol-prize_white.svg",
	"./symbol-sponsor.svg": "./src/assets/images/symbol-sponsor.svg",
	"./symbol-sponsor_white.svg": "./src/assets/images/symbol-sponsor_white.svg",
	"./timer-circle_full.svg": "./src/assets/images/timer-circle_full.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = ./src/assets/images recursive ^\.\/.*$
// module chunks = 0